import { z } from "zod";

// Create a schema that works in both server and client environments
const fileSchema = typeof window !== "undefined" && typeof File !== "undefined" 
  ? z.instanceof(File)
  : z.any();

export const uploadLeadSchema = z.object({
  file: z.array(fileSchema).min(1, "At least one file is required"),
});
export type TUploadLeadSchema = z.infer<typeof uploadLeadSchema>;
